export default {
    allFields: {
        orderId: 'Номер заказа',
        message: 'Описание проблемы',
        date: 'Дата алерта',
        priority: 'Приоритет',
    },

    priority: {
        high: 'Высокий',
        medium: 'Средний',
        low: 'Низкий',
    },

    empty: 'Нет актуальных алертов по заказам',
};